import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DTFHomepageService } from '../dtfhomepage/dtfhomepage.service';
import { AuthorizationService } from '../authorization/authorization.service';
import { WindowRef } from '../../utils/window';
import { TranslateService } from '@ngx-translate/core';
import { Banner } from '../../shared/models/banner';
import { TranslateUtil } from '../../utils/translate-util';
import { APP_CONSTANTS } from '../../utils/app-constants';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { AgreementDetailsList } from '../../shared/models/AgreementDetailsList';
import { SelectionModel } from '@angular/cdk/collections';
import { ContractNumberRequest } from '../../shared/models/contractNumberResponse';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogModule, MatDialogTitle} from '@angular/material/dialog';
import { AutoPaySignUpBeanList } from '../../shared/models/AutoPaySignUpBeanList';
import { AdminEntity } from '../../shared/models/AdminEntity';
// import { jsonpFactory } from '@angular/http/src/http_module';

import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { SharedTranslateModule } from '../../utils/sharedTranslateModule';
import { MatButtonModule } from '@angular/material/button';
import { SessionTimeoutComponent } from '../sessionTimeout/sessionTimeout.component';

export enum AutoPayEnum { //used for mat toggle
  Signup,
  Edit,
  Terminate,
  None
}

@Component({
    selector: 'div.dtf-adminportal',
    templateUrl: './adminportal.component.html',
    imports: [SharedTranslateModule,
        MatPaginator, MatSort, MatTableModule, MatCheckboxModule, SessionTimeoutComponent,MatFormFieldModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatSortModule
    ], providers: [],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ]
})


export class AdminPortalComponent implements OnInit {
  title = 'Content Section of the Page';
  router: Router;
  path = '';
  loginRedirect = '';
  accountRedirect = '';
  token: string;
  hideSingleSelectionIndicator=true;
  brandId: string;
  disableButton = false;
  action = '';
  loginAttempt = false;
  isLoginattempt = '';
  enrollFlagFromDB: string;
  countryFlag: string;
  langFlag: string;
  currentCountry: string;
  isCanadaPortal = false;
  baseUrl = '';
  currentPassword = '';
  currentPasswordDBCheckFlag = false;
  usUrl: string;
  caUrl: string;
  azURL: string;
  agentview: string;
  agentId: string;
  bodyLoaded = false;
  dbLoaded = false;
  isFrench = false;
  managePassword = false;
  passwordReset = false;
  hasUpperCase = false;
  hasLowerCase = false;
  hasNumeric = false;
  hasMinimum = false;
  hasMaximum = false;
  userIDcheck = false;
  reentercheck = false;
  confirmReset = false;
  confirmEnroll = false;
  confirmTerminate = false;
  confirmEbillReset = false;
  reentermailcheck = false;
  confirmMailReset = false;
  hide = false;
  hide1 = false;
  hide2 = false;
  openLoginModal = false;
  serviceErrorOccurred = false;
  serviceErrorDesc = '';
  userId = '';
  dbData: any;
  public alerts: Banner;
  toggleOpen: any;
  recAccCount = '';
  totalDue = '';
  language = '';
  emailOffers = true;
  isReset = false;
  userExist = false;
  marked = false;
  // theCheckbox = true;
  adminList: AdminEntity[];
  selectedadmin: AdminEntity;
  contractNumberList: ContractNumberRequest[];
  contract: ContractNumberRequest;
  autoPaySignUpBeanList: AutoPaySignUpBeanList[]; 
  AutoPaySignUpBean: AutoPaySignUpBeanList;
  displaycontractNumberList ='';
  adminPortalForm: FormGroup;
  isAP = false;
  isPC = false;
  SelectAutopaySignup = false;
  SelectAutopayEdit = false;
  SelectAutopayTerminate = false;
  tableLoaded = true;
  disabledFlag =false;
  dataLoaded=false;
  CANCEL = '';
  selectBankProfile = false;
  selectBankVerification = false;
  selectTerminate=false;
  accountValid = false;
  routingValid=false;
  newUserId ='';
  firstName='';
  lastName ='';
  phoneNumber='';
  email ='';
  AdminType: string;
  ActiveStatus:string;
  DisplayAccountType: string;
  signUp = false;
  editFlag = false;
  contractSelected = false;
  ValidationErrors = false;
  AutopayRequest = {};
  AutopayConfirmRequest= {};
  AutopayTerminateRequest = {};

  //used for mat-toggle
  toggleAutoPayEnum = AutoPayEnum;
  selectedAutopayState = AutoPayEnum.None;


  // Table columns
  initColumns: any[] = [
    {
      name: 'select',
      display: '',
      displayMobile: '',
      displayFR: '',
      dispFormat: ''
    },
    {
      name: 'userId',
      display: 'User Id',
      displayFR: 'User Id',
      dispFormat: ''
    },
    {
      name: 'firstname',
      display: 'First Name',
      displayFR: 'First Name',
      dispFormat: ''
    },
    {
      name: 'lastname',
      display: 'Last Name',
      displayFR: 'Last Name',
      dispFormat: ''
    },
    {
      name: 'email',
      display: 'Email',
      displayFR: 'Email',
      dispFormat: ''
    },
    {
      name: 'status',
      display: 'Status',
      displayFR: 'Status',
      dispFormat: ''
    }
    // ,{
    //   name: 'usertype',
    //   display: 'User Type',
    //   displayFR: 'User Type',
    //   dispFormat: ''
    // }
  ];
  displayedColumns: any[] = this.initColumns.map(col => col.name);

  filterActive = false;
  filter = false;
  rowCount = 0;
  value = '';


  dataSource: MatTableDataSource<AdminEntity>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  selection = new SelectionModel<AdminEntity>(false, []);
  
  constructor(router: Router, private dtfhomepageService: DTFHomepageService, private fb: FormBuilder, public auth: AuthorizationService,
    private _window: WindowRef, public translate: TranslateService, public translateUtil: TranslateUtil,public dialog: MatDialog

  ) {
    this.router = router;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
    this.adminList = [];
    this.autoPaySignUpBeanList = [];
    this.dataSource = new MatTableDataSource(this.adminList);
  }

  ngAfterViewInit() {
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    this.rowCount = this.dataSource.filteredData.length;
  }

  onChangeAdminButton($event) { //Used for mat-toggle conditions to filter DB
    this.selectedAutopayState = $event.value;
    this.disabledFlag = false;
    this.editFlag = false;
    
    if (this.selectedAutopayState === 0) {
      this.SelectAutopaySignup = true;
    }
    else if (this.selectedAutopayState === 1) {
      this.getAdminUsers('edit');
    }
  }

  ngOnInit() {
    sessionStorage.removeItem('admindialog');
    this.agentview = sessionStorage.getItem('agentview');
    this.agentId = sessionStorage.getItem('agentID');
    const language = (window as any).mbfs.language;
    this.language= language;
    const country = (window as any).mbfs.country;
    this.countryFlag = country;
    this.langFlag = language;
    this.brandId = sessionStorage.getItem('brandId');
    this.token = sessionStorage.getItem('ciamToken');

    this.translateUtil.setCountryAndLangFromUIProp();
    this.translateUtil.getCurrentCountry().subscribe(val => {
      this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
      this.currentCountry = val;
    });
    this.isFrench = ('fr-CA' === language) ? true : false; //checks if language is french or english for Canada

    //this.getAlerts();
    let element: HTMLElement = document.getElementById('auto_triggeradminportal') as HTMLElement;
    element.click();
    this.dataLoaded = true;
  }

  anouncementMgsopen(e: any) {
    e.preventDefault();
    if (this.toggleOpen) {
      this.toggleOpen = false;
    } else {
      this.toggleOpen = true;
    }
  }

  // getAlerts() {
  //   this.dtfhomepageService.getAlerts().subscribe((res) => {
  //     for (var i = 0; i < res.length; i++) {
  //       if (this.currentCountry === 'CA') {
  //         if (res[i].bannerType === 'Alert' && res[i].bannerName.indexOf((this.langFlag)) !== -1 &&
  //           res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'CA') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //       else {
  //         if (res[i].bannerType === 'Alert' && res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'US') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //     }
  //   });
  // }

  formValidationClasses = {
    'mbfs-error': true,
  };
  buildForm() {
    this.adminPortalForm = this.fb.group({
      newUserId: [''],
      firstName: [''],
      lastName: [''],
      email: [''],
      AdminType: [''],
      ActiveStatus: ['']
    });
  }

  onClickAdminPortal(e: Event): void {
    this.buildForm();
    this.openLoginModal = true;
  }

  getDashBoardDetails(dashBoardRequest) {
    this.auth.getDashBoardDetails(dashBoardRequest).subscribe(res => {
      this.recAccCount = res.recAccCount;
      this.totalDue = res.totalDue;
      if (this.totalDue.includes("-")) {
        this.totalDue = "0.00";
      }
    });
  }

  closeCIAMModal(e: Event) {
    this.openLoginModal = false;
    this.userExist = false;
    this.isReset = false;
    this.serviceErrorOccurred = false;
  }

  getAdminUsers( page:any){
    let fetchAdminListRequest = {};
    fetchAdminListRequest = {
      isAdmin: true
    };
    this.auth.fetchAdminList(fetchAdminListRequest).subscribe(res => {
      if (res.statusMessage === 'SUCCESS') {
        this.adminList = [];
        for(var i =0; i<res.adminList.length; i++){
        this.adminList.push(res.adminList[i]);
        }
        this.dataSource = new MatTableDataSource(this.adminList);
        setTimeout(()=>{
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.dbLoaded = true;
          this.filter = true;
      });
    if(page === 'edit'){
      this.SelectAutopayEdit = true;
    }
    } 
    });

  }


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }
  
  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSource.data.forEach(row => this.selection.select(row));
  }

   checkSingleToggleSelected(){
    this.contractNumberList = [];
    this.selectedadmin = new AdminEntity();
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    if(numSelected < 1){
      sessionStorage.setItem('admindialog', 'error');
      this.auth.SetErrorMessage('Please select at least one account');
      this.openDialog(5);
      this.contractSelected = false;
      this.tableLoaded = true;
        }
    else{
      this.contractSelected = true;      
      this.selectedadmin = this.selection.selected[0];   
      this.newUserId =this.selectedadmin.userId;
      this.firstName=this.selectedadmin.firstname;
      this.lastName =this.selectedadmin.lastname;
      this.email =this.selectedadmin.email;
      this.AdminType = this.selectedadmin.usertype;
      this.ActiveStatus = this.selectedadmin.status;
    }
   }

   openSelectedAdminEntity(){
    this.checkSingleToggleSelected(); //checks select Box
    if(this.contractSelected){
    // this.auth.SetObjData(this.contractNumberList);
    this.selectBankProfile= true;
    this.selectBankVerification = true;
    }
   }

   saveAdminDetails(portaltype:any){
    this.newUserId =this.adminPortalForm.get('newUserId').value;
    this.firstName=this.adminPortalForm.get('firstName').value;
    this.lastName =this.adminPortalForm.get('lastName').value;
    this.email =this.adminPortalForm.get('email').value;
    this.AdminType = this.adminPortalForm.get('AdminType').value;
    this.ActiveStatus = this.adminPortalForm.get('ActiveStatus').value;
    let AdminName = sessionStorage.getItem('AdminName');

    if(!this.newUserId){
      sessionStorage.setItem('payoffdialog', 'error');
      this.auth.SetErrorMessage('Please enter a valid User Id.');
      this.openDialog(5);
    }
    else if(!this.firstName){
      sessionStorage.setItem('payoffdialog', 'error');
      this.auth.SetErrorMessage('Please enter a valid first name.');
      this.openDialog(5);
    }
    else if(!this.lastName){
      sessionStorage.setItem('payoffdialog', 'error');
      this.auth.SetErrorMessage('Please enter a valid last name.');
      this.openDialog(5);
    }
    else if(!this.email){
      sessionStorage.setItem('payoffdialog', 'error');
      this.auth.SetErrorMessage('Please enter a valid email.');
      this.openDialog(5);
    }
    else if(!this.AdminType){
      sessionStorage.setItem('payoffdialog', 'error');
      this.auth.SetErrorMessage('Please enter a Admin Type.');
      this.openDialog(5);
    }
    else if(!this.email){
      sessionStorage.setItem('payoffdialog', 'error');
      this.auth.SetErrorMessage('Please enter a valid Status.');
      this.openDialog(5);
    }
    else{
    let AdminPortalRequest={};
    AdminPortalRequest = {
      newUserId: this.newUserId,
      firstname: this.firstName,
      lastname : this.lastName,
      email: this.email,
      status: this.ActiveStatus,
      usertype: this.AdminType,
      portaltype : portaltype,
      adminName: AdminName,
    }
    this.tableLoaded = false; //Spinner enabler
    this.auth.saveAdminDetails(AdminPortalRequest).subscribe(res => {
      this.tableLoaded = true; //Spinner disabled
      if (res.statusMessage === 'SUCCESS') {
        this.disableButton = true;
        const logReq = {
          adminId: sessionStorage.getItem('loginID'),
          actionType: portaltype +'_User',
          targetUser: this.newUserId,
          description: portaltype +' User Action performed',
          module: 'Admin_Portal',
          status: 'SUCCESS'
        };
        this.auth.saveAdminAuditLog(logReq).subscribe(res => {  });
        if(portaltype === "Add"){
          sessionStorage.setItem('admindialog', 'one');
          this.openDialog(1);
        }
        else{
          sessionStorage.setItem('admindialog', 'two');
          this.openDialog(2);
        }
      }
      else{
        this.disableButton = false;
        sessionStorage.setItem('admindialog', 'error');
        this.auth.SetErrorMessage('An unexpected error occurred. If you need any assistance with your account(s) please call Customer Service at 800-222-4221 or Fleet Services at 877-294-9679.');
        this.openDialog(5);
      }
    }); 
  }
}



  openDialog(num:any): void {
        if(num===1){
          sessionStorage.setItem('admindialog', 'one');
        }
        if(num===2){
          sessionStorage.setItem('admindialog', 'two');
        }
        if(num===5){
          sessionStorage.setItem('admindialog', 'error');
        }
      let dialogRef = this.dialog.open(AdminPortalDialogComponent, {
        maxWidth: '200vw',
        width: '500px',
      });
  }

}


@Component({
    selector: 'dialog-adminPortalPopup',
    imports: [
        MatTableModule, MatCheckboxModule, MatFormFieldModule, MatDialogModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatButtonModule,
        MatDialogContent, MatDialogActions,
        MatDialogClose,
    ],
    templateUrl: 'adminPortalDialog.component.html'
})
export class AdminPortalDialogComponent {
  usUrl: string;
  caUrl: string;
  admindialog: string;
  errorMessage: string;
  contractNumberList: ContractNumberRequest[];

  constructor(router: Router, private dtfhomepageService: DTFHomepageService, private fb: FormBuilder, public auth: AuthorizationService,
    private _window: WindowRef, public translate: TranslateService, public translateUtil: TranslateUtil

  ) {
    this.contractNumberList = [];
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
    this.admindialog = sessionStorage.getItem('admindialog');
    this.auth.cast2.subscribe((results:any)=> {
      this.contractNumberList = results;
     });
     this.auth.cast3.subscribe((errorMessage:any)=> {
      this.errorMessage = errorMessage;
     });
  }

autoPayRedirect(e: Event) {
  sessionStorage.setItem('skipterminate', 'yes');
    let redirect = '';
    this.translate.get('LoginModal.AutoPayRedirect').subscribe((data:any)=> {
      redirect= this.usUrl +  data;
     });
     window.location.href = redirect;
  }
}

